import { render, staticRenderFns } from "./product_group_new.vue?vue&type=template&id=319047d8&scoped=true&"
import script from "./product_group_new.vue?vue&type=script&lang=js&"
export * from "./product_group_new.vue?vue&type=script&lang=js&"
import style0 from "./product_group_new.vue?vue&type=style&index=0&id=319047d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319047d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('319047d8')) {
      api.createRecord('319047d8', component.options)
    } else {
      api.reload('319047d8', component.options)
    }
    module.hot.accept("./product_group_new.vue?vue&type=template&id=319047d8&scoped=true&", function () {
      api.rerender('319047d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/product_group_new.vue"
export default component.exports